import { getLeads, ParamsLeads } from "@/api/leads/get-leads";
import { useMutation } from "@tanstack/react-query";

/**
 * @deprecated Use from /hooks/queries instead
 */
export default function usePostLeadMutation() {
  return useMutation({
    mutationFn: async (data: ParamsLeads) => {
      const getLeadsRes = await getLeads(data);
      if (getLeadsRes.response.is_success) {
        if ("redirect_url" in getLeadsRes.response.return_data) {
          return {
            type: "redirect_url" as const,
            redirect_url: getLeadsRes.response.return_data.redirect_url,
          };
        } else {
          throw new Error(
            "FATAL: 'redirect_url' should be defined when API return 200 OK.",
          );
        }
      } else {
        if ("validation_errors" in getLeadsRes.response.return_data) {
          const errors = getLeadsRes.response.return_data.validation_errors;
          return {
            type: "validation_errors" as const,
            errors: errors,
            response: getLeadsRes.response,
          };
        } else {
          throw new Error(
            "FATAL: 'validation_errors' should be defined when API return 400 Status.",
          );
        }
      }
    },
  });
}
